import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

export default function Featured() {
  const featured = comics.slice(0, 8);
  const updated = comics.filter((c) => c.updateInfo.includes("今日"));

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
          <span className="text-xs font-semibold tracking-widest text-accent-500">FEATURED</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">本周专题推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">编辑精选的开挂主角漫画与逆袭流合集，闭眼入不踩雷</p>
        </div>
        <Link to="/recommend" className="inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap">
          看全部推荐<i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {featured.map((c) => (
          <ComicCard key={c.id} comic={c} />
        ))}
      </div>

      {/* 今日热更 */}
      <div className="mt-12 rounded-lg bg-background-100 border border-background-300/50 overflow-hidden">
        <div className="flex items-center justify-between gap-4 px-5 md:px-6 pt-5 pb-3">
          <div className="flex items-center gap-2">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary-500"></span>
            </span>
            <h3 className="font-heading text-lg md:text-xl text-foreground-950">今日热更</h3>
          </div>
          <span className="text-xs text-foreground-600">正在连载 · 每日更新</span>
        </div>
        <div className="px-5 md:px-6 pb-5 flex flex-col gap-2">
          {updated.map((c) => (
            <Link
              key={c.id}
              to={`/comic/${c.id}`}
              className="group flex items-center gap-3 rounded-lg bg-background-50 border border-background-300/40 px-4 py-3 hover:border-primary-500/50 transition-colors"
            >
              <span className="flex h-9 w-6 shrink-0 items-center justify-center rounded bg-primary-500/15 text-primary-400">
                <i className="ri-arrow-right-up-line"></i>
              </span>
              <div className="min-w-0 flex-1">
                <span className="font-heading text-sm md:text-base text-foreground-950 truncate block group-hover:text-primary-400 transition-colors">{c.title}</span>
                <span className="text-xs text-foreground-600">{c.updateInfo}</span>
              </div>
              <span className="shrink-0 text-xs text-accent-400 hidden sm:inline-flex items-center gap-0.5">
                <i className="ri-star-fill text-xs"></i>{c.rating.toFixed(1)}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}